<template>
    <v-container fluid grid-list-md>
        <v-dialog v-model="dialog" width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">
                        {{title}}
                    </span>
                </v-card-title>
                <v-card-text>
                    {{text}}
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat="flat" @click="dialog = false">{{close}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout row wrap>
            <v-flex d-flex xs12 sm6 md9>
                <v-card color="white">
                    <v-timeline dense clipped>
                        <v-timeline-item
                            class="mb-3"
                            small
                        >
                            <v-layout justify-space-between>
                                <v-flex xs4>
                                    {{latestNews.title}}
                                </v-flex>
                                <v-flex mr-2 xs5 text-xs-right>
                                    {{latestNews.date}}
                                </v-flex>
                            </v-layout>
                            <v-layout justify-space-between>
                                <v-flex xs7>
                                    <v-btn
                                        class="mx-0"
                                        color="white"
                                        @click="onRead(0, latestNews.language)"
                                    >
                                        {{latestNews.read}}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-timeline-item>

                        <v-timeline-item
                            class="mb-3"
                            small
                            color="grey"
                            :key="i"
                            v-for="(item, i) in newsArray"
                        >
                            <v-layout justify-space-between>
                                <v-flex xs4>
                                    {{item.title}}
                                </v-flex>
                                <v-flex mr-2 xs5 text-xs-right>
                                    {{item.date}}
                                </v-flex>
                            </v-layout>
                            <v-layout justify-space-between>
                                <v-flex xs7>
                                    <v-btn
                                        class="mx-0"
                                        color="white"
                                        @click="onRead(item.index, item.language)"
                                    >
                                        {{item.read}}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-timeline-item>
                    </v-timeline>
                </v-card>
            </v-flex>
            <v-flex d-flex xs12 sm6 md3>
                <v-card color="white">
                <v-card-text>
                    <p>{{ smallPart1 }}</p>
                    <p>{{ smallPart2a }}</p>
                    <p>{{ smallPart2b }}</p>
                    <p>{{ smallPart2c }}</p>

                    <p>{{ smallPart3a }}</p>
                    <p>{{ smallPart3b }}</p>
                    <p>{{ smallPart3c }}</p>

                    <p>{{ smallPart4a }}</p>
                    <p>{{ smallPart4b }}</p>
                    <p>{{ smallPart4c }}</p>
                </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import Dialog from './Dialog'

  import * as newsLatest from '../../store-modules/latest'
  import * as newsObj from '../../store-modules/news'

  export default {
    props: {
        mainPart: String,

        smallPart1: String,

        smallPart2a: String,
        smallPart2b: String,
        smallPart2c: String,

        smallPart3a: String,
        smallPart3b: String,
        smallPart3c: String,

        smallPart4a: String,
        smallPart4b: String,
        smallPart4c: String,

    },
    data () {
      return {
        dialog: false,
        index: 0,
        title: '',
        text: ''
      }
    },
    computed: {
        ...mapState('ContactModule', ['newsArray', 'latestNews', 'close']),
    },
    methods: {
        onRead(index, language){
            this.index = index;
            var temporalNewsObj = newsObj.data[language];
            console.log(index);
            console.log(temporalNewsObj);
            console.log(newsLatest.data[language]);
            if(index > 0){
                this.title = newsObj.data[language][index - 1].title;
                this.text = newsObj.data[language][index - 1].text;
            } else {
                this.title = newsLatest.data[language].title;
                this.text = newsLatest.data[language].text;
            }

            this.dialog = true;
        },
    }
  }
</script>
